import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PimaryComponentComponent } from './pimary-component/pimary-component.component';
import { PrintTicketComponent } from './print-ticket/print-ticket.component';
import { ValidarTicketComponent } from './validar-ticket/validar-ticket.component';


const routes: Routes = [{ path: '', redirectTo: '/home', pathMatch: 'full' },
{ path: 'home', component: PimaryComponentComponent },
{ path: 'print-ticket', component: PrintTicketComponent },
{ path: 'login', component: LoginComponent },
{ path: 'validar-ticket', component: ValidarTicketComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
